module.exports = __webpack_public_path__ + "img/domain.1f8cfe5f.png";